import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { Callout } from '../../utils/useProductCallout';
import useUnlockedXclusive from '../../utils/useUnlockedXclusive';
import { Component as ProductFlag } from '../ProductFlag';

const Wrapper = styled.div``;

function ProductCallout({ type, value, ...rest }) {
  const { shouldSeeUnlockedXclusiveBadge } = useUnlockedXclusive();

  const calloutMessage = useMemo(() => {
    switch (type) {
      case Callout.CUSTOM_TAG:
        return (
          <FormattedMessage
            id="global_checkout.custom_tag_label"
            defaultMessage="Custom Tag"
          />
        );
      case Callout.CRITICAL_STOCK:
      case Callout.LOW_IN_STOCK:
        return (
          <FormattedMessage
            id="global_checkout.almost_gone"
            defaultMessage="Almost Gone!"
          />
        );
      case Callout.RIHANNAS_PICK:
        return (
          <FormattedMessage
            id="global_checkout.rihannas_pick_label"
            defaultMessage="Rihanna’s Pick"
          />
        );
      case Callout.PRE_ORDER:
        return (
          <ProductFlag productTag="shopItEarly">
            <FormattedMessage
              id="global_checkout.pre_order_label"
              defaultMessage="Pre-order"
            />
          </ProductFlag>
        );
      case Callout.BACK_IN_STOCK:
        return (
          <FormattedMessage
            id="global_checkout.back_in_stock_label"
            defaultMessage="Back in Stock"
          />
        );
      case Callout.BEST_SELLER:
        return (
          <FormattedMessage
            id="global_checkout.best_seller_label"
            defaultMessage="Best seller"
          />
        );
      case Callout.TOP_RATED:
        return (
          <FormattedMessage
            id="global_checkout.top_rated_label"
            defaultMessage="Top Rated"
          />
        );
      case Callout.NEW:
        return (
          <FormattedMessage
            id="global_checkout.new_label"
            defaultMessage="New"
          />
        );
      case Callout.TRENDING:
        return (
          <FormattedMessage
            id="global_checkout.trending_label"
            defaultMessage="Trending"
          />
        );
      case Callout.UNLOCKED_XCLUSIVE:
        if (!shouldSeeUnlockedXclusiveBadge) {
          return null;
        }
        return (
          <>
            <ProductFlag productTag="unlockedExclusive">
              <FormattedMessage
                id="global_checkout.unlocked_xclusive_label"
                defaultMessage="Unlocked Xclusive"
              />
            </ProductFlag>
          </>
        );
      case Callout.CUSTOMIZABLE:
        return (
          <FormattedMessage
            id="global_checkout.customizable"
            defaultMessage="Customizable"
          />
        );
      case Callout.YOUNIVERSAL:
        return (
          <FormattedMessage
            id="global_checkout.youniversal"
            defaultMessage="YOUniversal"
          />
        );
      default:
        // TODO: Get logger's debug working
        // debug('No callout found for %s', type);
        return null;
    }
  }, [shouldSeeUnlockedXclusiveBadge, type, value]);

  return calloutMessage ? (
    <Wrapper
      data-autotag="grid-product-callout"
      data-qa-automation="gridItemLabel"
      {...rest}
    >
      {calloutMessage}
    </Wrapper>
  ) : null;
}

ProductCallout.propTypes = { type: PropTypes.string, value: PropTypes.any };

export default ProductCallout;
